<template>
  <b-row>
    <b-col cols="12">
      <b-card body-class="py-md-1 px-md-2 py-0 px-1">
        <b-row>
          <b-col
            class="mb-xl-0 mb-md-3 mb-1 px-sm-1 px-0 d-flex justify-content-center align-items-center"
            cols="12"
            xl="4"
          >
            <b-skeleton
              width="300px"
              height="300px"
              v-if="loading"
            ></b-skeleton>
            <div
              v-else
              style="max-height: 250px"
              class="d-flex justify-content-center align-items-center w-100"
            >
              <b-img
                @error="setAltImg"
                :src="semester.banner || errorImage"
                fluid
                :alt="semester.name"
                style="max-height: 250px"
              ></b-img>
            </div>
          </b-col>
          <b-col cols="12" xl="8">
            <b-skeleton width="80px" height="30px" v-if="loading"></b-skeleton>
            <template v-else>
              <h2 class="font-weight-bold d-none d-md-block">
                {{ semester.name }}
              </h2>
              <h3 class="font-weight-bold d-block d-md-none">
                {{ semester.name }}
              </h3>
            </template>
            <b-media no-body>
              <b-media-body
                class="d-flex flex-wrap justify-content-between w-100 my-1"
              >
                <b-skeleton
                  width="200px"
                  height="20px"
                  v-if="loading"
                  class="mr-2 mb-1"
                ></b-skeleton>
                <div
                  class="d-flex mr-2 mb-1 flex-wrap"
                  v-else-if="semester.started_at"
                >
                  <span>
                    <feather-icon size="14" icon="CalendarIcon" /> تاریخ شروع :
                  </span>

                  <span>{{ calcDate(semester.started_at) }}</span>
                </div>
                <b-skeleton
                  width="200px"
                  height="20px"
                  v-if="loading"
                  class="mr-2 mb-1"
                ></b-skeleton>

                <div
                  class="d-flex mr-2 mb-1 flex-wrap"
                  v-else-if="semester.ended_at"
                >
                  <span
                    ><feather-icon size="14" icon="CalendarIcon" /> تاریخ پایان
                    :
                  </span>

                  <span>{{ calcDate(semester.ended_at) }}</span>
                </div>
                <b-skeleton
                  width="200px"
                  height="20px"
                  v-if="loading"
                  class="mb-1"
                ></b-skeleton>

                <div class="d-sm-flex d-none mb-1" v-else>
                  <span> وضعیت : </span>

                  <b-badge
                    :variant="semester.active ? 'success' : 'danger'"
                    class="rounded"
                  >
                    {{ semester.active ? "فعال" : "غیر فعال" }}
                  </b-badge>
                </div>
                <div class="d-lg-none d-block w-100">
                  <div
                    v-show="
                      !semester.bought && semester.can_buy && availableAtTimer
                    "
                  >
                    <div
                      class="d-flex justify-content-sm-between justify-content-center w-100 flex-wrap text-info my-25 font-weight-bold"
                    >
                      <div class="my-25">زمان باقی مانده تا شروع ثبت نام :</div>
                      <timer
                        class="flex-row"
                        color="info"
                        :time="semester.available_at"
                        v-model="availableAtTimer"
                      />
                    </div>
                  </div>
                  <div
                    v-show="
                      !semester.bought &&
                      semester.can_buy &&
                      !availableAtTimer &&
                      unavailableAtTimer
                    "
                  >
                    <div
                      class="d-flex justify-content-sm-between justify-content-center w-100 flex-wrap text-danger my-25 font-weight-bold"
                    >
                      <div class="my-25">
                        زمان باقی مانده تا پایان مهلت ثبت نام :
                      </div>
                      <timer
                        class="flex-row"
                        color="danger"
                        :time="semester.unavailable_at"
                        v-model="unavailableAtTimer"
                      />
                    </div>
                  </div>
                </div>
              </b-media-body>
            </b-media>
            <b-skeleton width="100%" height="300px" v-if="loading"></b-skeleton>
            <div class="pt-xl-2 pt-0" v-else-if="semester.brief_description">
              <span class="font-weight-bold d-sm-flex d-none h5">توضیحات</span>
              <div
                v-html="semester.brief_description"
                class="text-justify py-1"
              />
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col cols="12" class="d-md-none d-flex">
      <term-sidebar
        :loading="loading"
        :roadmaps="roadmaps"
        :semester="semester"
        class="w-100"
      />
    </b-col>
    <b-col class="mb-sm-0 mb-2">
      <div v-show="loading">
        <div class="d-flex justify-content-center w-100">
          <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
          <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
          <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
        </div>
        <b-skeleton width="100%" height="300px"></b-skeleton>
      </div>
      <b-tabs
        content-class="col-12 px-sm-1 px-0 mb-sm-0 mb-5"
        pills
        v-model="tab"
        nav-wrapper-class=" col-12"
        nav-class="justify-content-center"
        v-show="!loading"
      >
        <b-tab v-if="semester.description">
          <template #title>
            <feather-icon icon="BookOpenIcon" size="18" class="mr-1" />
            <span class="font-weight-bold">توضیحات</span>
          </template>
          <b-card>
            <div
              class="text-justify p-sm-1"
              v-html="semester.description"
            ></div>
          </b-card>
        </b-tab>

        <b-tab
          v-if="
            semester.faqs && semester.faqs.faqs && semester.faqs.faqs.length
          "
        >
          <template #title>
            <feather-icon icon="FileTextIcon" size="18" class="mr-1" />
            <span class="font-weight-bold">پرسش و پاسخ</span>
          </template>
          <app-collapse accordion type="margin">
            <app-collapse-item
              v-for="(faq, index) in semester.faqs.faqs"
              :key="index"
              :title="faq.question"
            >
              {{ faq.answer }}
            </app-collapse-item>
          </app-collapse>
        </b-tab>

        <b-tab>
          <template #title>
            <feather-icon icon="TwitchIcon" size="18" class="mr-1" />
            <span class="font-weight-bold">سوالات کاربران</span>
          </template>
          <Comments regardingType="semester" />
        </b-tab>
      </b-tabs>
      <b-row
        v-if="userData.permissions && userData.permissions.permissions.length"
      >
        <b-col cols="12" sm="6">
          <user-of-semester />
        </b-col>
        <b-col cols="12" sm="6">
          <semester-progress :PropProgress="progressShow" />
        </b-col>
        <b-col cols="12" sm="12">
          <semester-statistics @semesterProgress="setprogress" />
        </b-col>
        <b-col cols="12" sm="12">
          <latest-login />
        </b-col>
        <b-col cols="12" sm="12">
          <last-comments />
        </b-col>
        <b-col cols="12" sm="12">
          <last-invoices :roadmaps="roadmaps" />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormInput,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BLink,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BTabs,
  BTab,
  BSkeleton,
} from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import Ripple from "vue-ripple-directive";
import Comments from "@core/components/comments/Comments.vue";
import Timer from "@core/components/timer/Timer.vue";
import TermSidebar from "./Sidebar.vue";
import userOfSemester from "./userOfSemester.vue";
import semesterStatistics from "./semesterStatistics.vue";
import lastComments from "@/views/pages/dashboard/lastComments.vue";
import lastInvoices from "@/views/pages/dashboard/lastInvoices.vue";
import semesterProgress from "./semesterProgress.vue";
import latestLogin from "@/views/pages/dashboard/latestLogin.vue";

export default {
  components: {
    BFormInput,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BBadge,
    BCardText,
    BDropdown,
    BForm,
    BDropdownItem,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    AppCollapse,
    AppCollapseItem,
    BTabs,
    BTab,
    BSkeleton,
    Comments,
    Timer,
    TermSidebar,
    userOfSemester,
    semesterStatistics,
    lastComments,
    lastInvoices,
    semesterProgress,
    latestLogin,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      availableAtTimer: true,
      unavailableAtTimer: true,
      tab: 0,
      progressShow: {},
    };
  },
  watch: {
    semester(val) {
      setTimeout(() => {
        this.tab = 0;
      }, 100);
    },
  },

  computed: {
    finalAmount() {
      let finalAmount = 0;
      if (this.semester.percentage) {
        finalAmount =
          Number(this.semester.amount) -
          (Number(this.semester.amount) * Number(this.semester.rebate)) / 100;
      } else {
        finalAmount =
          Number(this.semester.amount) - Number(this.semester.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  props: {
    semester: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    roadmaps: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    setprogress(val) {
      this.progressShow = val;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .card-title {
  font-size: 1.9rem;
}
</style>
